import PropTypes, {InferProps} from "prop-types";
import {usePrincipal, useProject} from "@betrue/front/services";
import {ProjectDetailsView} from "./project-details.view";


export const ProjectDetailsPropsTypes = {
  editUrl: PropTypes.string,
  editLabel: PropTypes.string,

  projectProductsLabel: PropTypes.string,
  projectNameLabel: PropTypes.string,
  projectDeadLineLabel: PropTypes.string,
  projectDescriptionLabel: PropTypes.string,
  projectStateLabel: PropTypes.string,
  projectStatePendingLabel: PropTypes.string,
  projectStateStartedLabel: PropTypes.string,
  projectStateCanceledLabel:+ PropTypes.string

}
export type ProjectDetailsProps = InferProps<typeof ProjectDetailsPropsTypes>

export const ProjectDetails = (props: ProjectDetailsProps) => {
  const [currentProject, , {createProject, updateProject, getProjectById}] = useProject()

  const [principal] = usePrincipal()

  if (!principal || !currentProject.id) return (<>...</>)
  return (
    <ProjectDetailsView {...props} currentUser={principal}
                        project={currentProject}/>
  );
}

ProjectDetails.propTypes = ProjectDetailsPropsTypes
